import React from 'react';
import { createSvgIcon } from '@material-ui/core';

export const MessagingParkingLotIcon = createSvgIcon(
    <svg fill="#000000" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" xmlSpace="preserve">
        <g id="SVGRepo_bgCarrier" strokeWidth="0" />
        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
        <g id="SVGRepo_iconCarrier">
            <g>
                <g>
                    <g>
                        <path d="M256,0C114.837,0,0,114.837,0,256s114.837,256,256,256s256-114.837,256-256S397.163,0,256,0z M277.333,277.333h-42.667 v128c0,11.776-9.536,21.333-21.333,21.333c-11.797,0-21.333-9.557-21.333-21.333V256V128c0-11.776,9.536-21.333,21.333-21.333h64 c47.061,0,85.333,38.272,85.333,85.333S324.395,277.333,277.333,277.333z" />
                        <path d="M277.333,149.333h-42.667v85.333h42.667C300.864,234.667,320,215.531,320,192S300.864,149.333,277.333,149.333z" />
                    </g>
                </g>
            </g>
        </g>
    </svg>
    ,
    'Messaging - Paking Lot',
);

